import apiClient from "../apiClient";

const resource = "EmployeeLeaves";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    add: payload => apiClient.post(`${resource}`, payload,{ 'Content-Type': 'multipart/form-data' }),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    getForPrint: id => apiClient.get(`${resource}/${id}/print`),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload,{ 'Content-Type': 'multipart/form-data' }),
    returnLeaves: (id, payload) => apiClient.put(`${resource}/${id}/return`, payload,{ 'Content-Type': 'multipart/form-data' }),

    delete: id => apiClient.delete(`${resource}/${id}`),
    getVacationsBalance: (params) => apiClient.get(`${resource}/vacationsBalance?${params}`),
    approve: id => apiClient.put(`${resource}/${id}/approve`),
    reject: id => apiClient.put(`${resource}/${id}/reject`),

};